import { SearchOutlined, StarFilled, StarOutlined, ZoomInOutlined, FileSearchOutlined, UploadOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Card, Checkbox, Col, Divider, Empty, Flex, Radio, Row, Select, Space, Spin, Typography, message, Upload, Dropdown } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { splitArray2Parts, generateThumbnailBase64 } from "@/utils/commons";
import { useAuthStore } from "../stores/useAuthStore";
import { useMediaStore } from "../stores/useMediaStore";

function ImageSearch() {
	const navigate = useNavigate();

	const [messageApi, contextHolder] = message.useMessage();
	const imageSearchRef = useRef();
	//store states
	const userId = useAuthStore(s => s.userId);
	const imageSearchList = useMediaStore(s => s.imageSearchList);
	const getKeywordHistory = useMediaStore(s => s.getKeywordHistory);
	const fetchOptionList = useMediaStore(s => s.fetchOptionList);
	const fetchImageList = useMediaStore(s => s.fetchImageList);
	const fetchImageList_by_image = useMediaStore(s => s.fetchImageList_by_image);
	const fetchImageList_by_base64 = useMediaStore(s => s.fetchImageList_by_base64);
	const selectImage = useMediaStore(s => s.selectImage);
	const toggleFavorite = useMediaStore(s => s.toggleFavorite);
	const fetchCityList = useMediaStore(s => s.fetchCityList);
	//component states
	const [tagSelectOptions, setTagOptions] = useState([]);
	const [selectedStarList, setStarList] = useState([]);
	const [selectedTagList, setTagList] = useState([]);
	const [selectedCopyrightList, setCopyrightList] = useState([]);
	const [selectedType, setSearchType] = useState("library");
	const [selectedCountry, setCountry] = useState("");
	const [selectedCity, setCity] = useState("");
	const [inputKeyword, setKeyword] = useState("");
	const [serachLoading, setSearchLoading] = useState(false);
	const [checkAllStar, setCheckAllStar] = useState(false);
	const [countrySelectOptions, setCountrySelectOptions] = useState([]);
	const [citySelectOptions, setCitySelectOptions] = useState([]);
	const [keywordHistoryOptions, setkeywordHistoryOptions] = useState([]);
	const [renderLength, setRenderLength] = useState(4);
	const [sortKey, setSortKey] = useState("1");

	const sortedImageList = useMemo(() => {
		if (sortKey === "2") {
			return [...imageSearchList].sort((a, b) => b.PII_UseCount - a.PII_UseCount);
		}
		return imageSearchList;
	}, [imageSearchList, sortKey]);

	let imageSplittedList = splitArray2Parts(sortedImageList, 4);

	useEffect(() => {
		setkeywordHistoryOptions(getKeywordHistory());
		fetchOptionList().then(result => {
			setCountrySelectOptions(result.countryOptionList);
			setCitySelectOptions(result.cityOptionList);
			setTagOptions(result.tagOptionList);
		});
	}, []);

	useEffect(() => {
		let timer = null;
		const viewClintHeight = document.documentElement.clientHeight;
		const scrollCallback = e => {
			if (timer) clearTimeout(timer);
			timer = setTimeout(() => {
				const obj = imageSearchRef.current.getBoundingClientRect();
				if (obj.bottom <= viewClintHeight) setRenderLength(renderLength + 4);
			}, 100);
		};
		window.addEventListener("scroll", scrollCallback);

		return () => {
			window.removeEventListener("scroll", scrollCallback);
		};
	}, [imageSearchList, renderLength]);

	const items = [
		{
			label: '默认排序',//默认排序是按照图片标签和最新图片排的
			key: '1',
		},
		{
			label: '图片使用次数排序',
			key: '2',
		},
	];
	const handleMenuClick = e => {
		setSortKey(e.key);
	};
	const menuProps = {
		items,
		onClick: handleMenuClick,
	};

	function search() {
		setSearchLoading(true);
		fetchImageList(selectedCountry, selectedCity, inputKeyword, selectedTagList.join(","), selectedStarList.join(","), selectedCopyrightList.join(","), selectedType, userId).finally(() => {
			setSearchLoading(false);
			setkeywordHistoryOptions(getKeywordHistory());
		});
	}

	function imageColumnRender(imageColumn, index) {
		const originNameArr = imageColumn.PII_FileName.split(".");
		const thumbnailUrl = "https://p9axztuwd7x8a7.mycht.cn/service-fileServer" + imageColumn.PII_Location + originNameArr[0] + "-m." + originNameArr[1];
		const originUrl = "https://p9axztuwd7x8a7.mycht.cn/service-fileServer" + imageColumn.PII_Location + imageColumn.PII_FileName;
		const countryName = imageColumn.PII_CountryCN || "未知";
		const cityName = imageColumn.CII_Name || "未知";
		const imageSize = imageColumn.PII_Width + "*" + imageColumn.PII_Height;
		const copyrightText = () => {
			// PII_CopyRight 版权：1使用权，2使用权（网站）3版权不明 4无版权 5全版权 6版权不明（接口上传） 7 版权不明（微信上传） 8无版权酒店图片
			switch (imageColumn.PII_CopyRight) {
				case 1:
					return "使用权";
				case 2:
					return "使用权（网站）";
				case 3:
					return "版权不明";
				case 4:
					return "无版权";
				case 5:
					return "全版权";
				case 6:
					return "版权不明（接口上传）";
				case 7:
					return "版权不明（微信上传）";
				case 8:
					return "无版权酒店图片";
				default:
					return "未知";
			}
		};
		const imageChecked = imageColumn.Checked == 1;
		// 审核过或者特定人员（客服、产品）才能裁剪酒店无版权图片
		const canCrop = imageChecked || (imageColumn.PII_CopyRight === 8 && imageColumn.SpecificPerson === 1);
		const imageCursor = canCrop ? "pointer" : "not-allowed";
		return (
			<Col span={6} key={index}>
				<Card
					hoverable
					style={{
						width: "100%",
						cursor: imageCursor,
					}}
					bodyStyle={{
						padding: 0,
						overflow: "hidden",
					}}>
					<Flex justify="space-between" vertical={true}>
						<img
							style={{
								cursor: imageCursor,
								width: "100%",
								height: 200,
								objectFit: "scale-down",
								objectPosition: "center",
							}}
							alt={imageColumn.PII2_Name}
							onClick={() => {
								if (canCrop) {
									selectImage(imageColumn);
									// navigate("/image/crop");
                  window.open('/image/crop', '_blank');
								} else {
									messageApi.error("未审核图片不能裁剪");
								}
							}}
							src={thumbnailUrl}
							lazy="true"
						/>
						<Flex
							vertical
							align="flex-start"
							justify="flex-start"
							style={{
								padding: 16,
							}}>
							<Typography.Text
								strong={true}
								ellipsis={{
									tooltip: imageColumn.PII_ShortIntro,
								}}
								style={{ fontSize: 16 }}>
								{imageColumn.PII_ShortIntro}
							</Typography.Text>
							<Typography.Text
								strong={true}
								ellipsis={{
									tooltip: imageColumn.PII2_Intro,
								}}
								style={{ fontSize: 16 }}>
								{imageColumn.PII2_Intro}
							</Typography.Text>
							<Typography.Text>{countryName + ", " + cityName}</Typography.Text>
							<Typography.Text>
								{"尺寸：" + imageSize}； {"版权：" + copyrightText()}
							</Typography.Text>
							<Typography.Text type="secondary">
								{"使用次数：" + imageColumn.PII_UseCount + "次"}
							</Typography.Text>
							<Flex vertical={false} justify="center" align="center" style={{ padding: 0, width: "100%" }}>
								<Button type="text" block icon={<ZoomInOutlined />} target="_blank" href={originUrl} title="查看原图" />
								<Divider type="vertical" />
								<Button
									type="text"
									title="收藏"
									block
									style={imageColumn.isFavorite ? { color: "#8cc269" } : {}}
									icon={imageColumn.isFavorite ? <StarFilled /> : <StarOutlined />}
									onClick={() => {
										toggleFavorite(imageColumn, userId);
									}}
								/>
								<Divider type="vertical" />
								<Button
									type="text"
									block
									icon={<FileSearchOutlined />}
									onClick={() => {
										setSearchLoading(true);
										fetchImageList_by_image(imageColumn.PII_SN).finally(() => {
											setSearchLoading(false);
										});
									}}
									title="查相似图片"
								/>
							</Flex>
						</Flex>
					</Flex>
				</Card>
			</Col>
		);
	}

	function imageRowRender(imageRow, index) {
		return (
			<Row gutter={[16, 16]} key={index} align="middle">
				{imageRow.map(imageColumnRender)}
			</Row>
		);
	}

	const [imageUrl, setImageUrl] = useState();
	// 处理图片上传并生成缩略图
	const handleImageUpload = ({ file }) => {
		setImageUrl(URL.createObjectURL(file));
		setSearchLoading(true);
		// 使用commons.js中的generateThumbnailBase64函数生成缩略图base64
		generateThumbnailBase64(file)
			.then(base64 => {
				// 使用生成的base64进行图片搜索
				fetchImageList_by_base64(base64).finally(() => {
					setSearchLoading(false);
				});
			})
			.catch(error => {
				setSearchLoading(false);
				messageApi.error("失败: " + error.message);
			});
	};

	return (
		<Spin spinning={serachLoading} delay={500}>
			{contextHolder}
			<Space direction="vertical" style={{ width: "100%" }}>
				<Row gutter={[16, 16]} justify="start" align="middle">
					<Col span={24}>
						<Radio.Group
							options={[
								{ label: "所有图片", value: "library" },
								{ label: "所有用过的", value: "allused" },
								{ label: "我用过的", value: "myused" },
								{ label: "我上传的", value: "myupload" },
								{ label: "我收藏的", value: "myfavorites" },
								{ label: "未审核", value: "unCheck" },
							]}
							value={selectedType}
							onChange={({ target: { value } }) => {
								setSearchType(value);
							}}
							optionType="button"
							buttonStyle="solid"
						/>
					</Col>
				</Row>
				<Row gutter={[16, 16]} justify="start" align="middle">
					<Col span={4}>
						<Select
							style={{ width: "100%" }}
							showSearch
							value={[selectedCountry]}
							placeholder="国家"
							onChange={value => {
								setCountry(value);
								fetchCityList(value).then(result => {
									setCitySelectOptions(result);
								});
							}}
							filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
							options={countrySelectOptions}
						/>
					</Col>
					<Col span={4}>
						<Select
							style={{ width: "100%" }}
							placeholder="城市"
							value={[selectedCity]}
							showSearch
							onChange={value => {
								setCity(value);
							}}
							filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
							options={citySelectOptions}
						/>
					</Col>
					<Col span={5}>
						<AutoComplete
							style={{ width: "100%" }}
							options={keywordHistoryOptions}
							value={inputKeyword}
							placeholder="图片名，多个关键词之间使用空格分开"
							onChange={value => {
								setKeyword(value);
							}}
              onInputKeyDown={(event) => {
                if (event.key === 'Enter') {
								  search();
                }
							}}
							filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
						/>
					</Col>
				</Row>
				<Row justify="middle">
					<Col span={5}>
						<Checkbox.Group
							value={selectedStarList}
							options={[
								{ label: "五星", value: "5" },
								{ label: "四星", value: "4" },
								{ label: "三星", value: "3" },
							]}
							onChange={list => {
								setStarList(list);
							}}
						/>
						<Checkbox
							indeterminate={false}
							onChange={e => {
								setCheckAllStar(e.target.checked);
								setStarList(e.target.checked ? ["3", "4", "5"] : []);
							}}
							checked={checkAllStar}>
							全部
						</Checkbox>
					</Col>
					<Col span={4}>
						<Checkbox.Group
							options={tagSelectOptions}
							onChange={list => {
								setTagList(list);
							}}
						/>
					</Col>
					<Col span={5}>
						<Checkbox.Group
							value={selectedCopyrightList}
							options={[{ label: "全版权", value: "5" }]}
							onChange={list => {
								setCopyrightList(list);
							}}
						/>
					</Col>
					<Col span={2}>
						<Button
							icon={<SearchOutlined />}
							onClick={() => {
								search();
							}}>
							搜索
						</Button>
					</Col>
					<Col span={2}>
						<Upload beforeUpload={() => false} multiple={false} onChange={handleImageUpload} maxCount={1} showUploadList={false} accept="image/*">
							{imageUrl ? <img draggable={false} src={imageUrl} alt="avatar" style={{ width: "100%" }} /> : <Button icon={<UploadOutlined />}>以图搜图</Button>}
						</Upload>
					</Col>
					<Col span={2}>
						<Dropdown menu={menuProps}>
							<Button>
								排序
							</Button>
						</Dropdown>
					</Col>
				</Row>
			</Space>
			<Divider plain orientation="left">
				图片列表(共 {imageSearchList.length} 张)
			</Divider>
			<Space
				ref={imageSearchRef}
				direction="vertical"
				size="middle"
				style={{
					display: "flex",
				}}>
				{imageSplittedList.length > 0 ? imageSplittedList.slice(0, renderLength).map(imageRowRender) : <Empty description={false} />}
			</Space>
		</Spin>
	);
}

export default ImageSearch;
